import { useId } from "react";

import { cn } from "@/lib/utils";

export function DistanceIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  const id = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("aspect-17/26 h-6.5 w-[17px] text-mystic-blue", className)}
      preserveAspectRatio="xMinYMin meet"
      viewBox="0 0 17 26"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M8.5.25a8.5 8.5 0 00-7.238 12.96L8.5 25.75l7.291-12.629A8.5 8.5 0 008.5.25z"
        fill={`url(#${id})`}
        fillRule="evenodd"
      />
      <circle cx="8.5" cy="8.75" fill="currentColor" r="3.643" />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={id}
          x1="4.25"
          x2="-7.519"
          y1="6.625"
          y2="14.471"
        >
          <stop stopColor="#bd2885" />
          <stop offset="1" stopColor="#90278e" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function FlashIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  const id = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("h-5 w-4", className)}
      fill="none"
      viewBox="0 0 16 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter={`url(#${id}a)`}>
        <path
          clipRule="evenodd"
          d="M7.869 3.044l-.167.308a10615.463 10615.463 0 01-2.574 4.755 1440.348 1440.348 0 01-1.196 2.209c-.087.16.034.353.223.353l.974.002a62.79 62.79 0 011.389.01 445.73 445.73 0 00-.26.486l-.224.414a2168.863 2168.863 0 01-1.404 2.592l-.286.53a3211.762 3211.762 0 01-1.242 2.29c-.014.024.03-.01.173-.13a396.449 396.449 0 011.182-.989 2333.308 2333.308 0 013.18-2.66 697.984 697.984 0 011.644-1.375 412.404 412.404 0 01.98-.819l.638-.533c.312-.26.536-.448 1.14-.955.076-.062.03-.181-.07-.181l-1.1-.002a68.652 68.652 0 01-1.387-.01c0-.004.076-.147.169-.319a683.35 683.35 0 00.82-1.514 3586.066 3586.066 0 001.845-3.407l.36-.665c.123-.227.224-.417.224-.423 0-.008-.735-.011-2.504-.011H7.944a.084.084 0 00-.075.044z"
          fill={`url(#${id}b)`}
          fillRule="evenodd"
        />
      </g>
      <g filter={`url(#${id}c)`}>
        <path
          clipRule="evenodd"
          d="M11.467 3L7.65 10h2.8L3.1 17l.03-.018c.028-.02.075-.059.145-.118l.588-.492.595-.498L5.98 14.6l.255-.214.806-.674.595-.498.535-.448a762.781 762.781 0 001.526-1.275l.562-.47a742.219 742.219 0 001.78-1.488c.075-.063.028-.182-.071-.182l-1.1-.002a68.56 68.56 0 01-1.388-.01c0-.004.076-.147.17-.319l.317-.586.503-.928.51-.944a706.978 706.978 0 011.037-1.913l.297-.55.361-.666c.123-.226.223-.416.223-.422 0-.006-.432-.01-1.432-.01z"
          fill={`url(#${id}d)`}
          fillRule="evenodd"
        />
      </g>
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}b`}
          x1="3.358"
          x2="16.549"
          y1="16.067"
          y2="6.634"
        >
          <stop stopColor="#ffcf55" />
          <stop offset="1" stopColor="#bd2885" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}d`}
          x1="2.308"
          x2="15.498"
          y1="16.767"
          y2="7.335"
        >
          <stop stopColor="#c79b29" />
          <stop offset="1" stopColor="#bd2885" />
        </linearGradient>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="19.6"
          id={`${id}a`}
          width="15.4"
          x="0.3"
          y="0.2"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="1.4" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0.929348 0 0 0 0 0.44144 0 0 0 0 0.524009 0 0 0 0.1 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_18271_77694"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_18271_77694"
            result="shape"
          />
        </filter>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="19.599"
          id={`${id}c`}
          width="15.4"
          x="0.3"
          y="0.2"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="1.4" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0.929348 0 0 0 0 0.44144 0 0 0 0 0.524009 0 0 0 0.2 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_18271_77694"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_18271_77694"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}

export function HaloweenIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  const id = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("h-5 w-[23px]", className)}
      viewBox="0 0 23 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.452 1.151c.182.134.338.3.485.47.184.211.342.474.446.733.36.894.114 1.9-.397 2.686l.625.284c.158-.124.502-.345.979-.37.452-.024.859.155 1.067.27.087-.113.175-.21.263-.301-.464-.44-.753-1.031-.931-1.648-.116-.4-.18-.812-.293-1.213a8.233 8.233 0 00-.233-.72c-.268-.7-.737-1.336-1.558-1.33-.372.003-.952.203-.876.678.035.217.263.342.423.461z"
        fill={`url(#${id}-a)`}
      />
      <path
        d="M22.427 8.61c-.285-.711-1.788-3.018-3.297-3.783-1.509-.765-2.91-.494-3.762-.226 0 0-.713-.143-1.16-.041-.45.101-1.012.409-1.498 1.106 0 0-.512-.36-1.105-.33-.593.033-.959.402-.959.402l-1.039-.473c-.704-.327-2.291-.75-3.731-.687-1.44.063-2.584.758-3.645 1.81C1.169 7.44.413 9.548.087 11.168c-.326 1.62.263 4.535 1.748 5.982 1.486 1.447 2.576 1.812 4.615 1.808 0 0 1.003.654 2.192.848 1.19.194 2.005.075 3.105-.277 0 0 .495.444 1.065.47.569.025 1.078-.325 1.443-.781 0 0 .233.306.858.362.625.056 1.38-.312 1.681-.58 0 0 .948.246 1.767.029.82-.217 1.283-.633 1.94-1.33.659-.696 1.812-2.449 2.308-4.571.495-2.123-.096-3.809-.382-4.519zM15.08 7.034l2.537 3.082-3.723.552 1.186-3.634zm-6.515.143l1.354 3.604-3.697-.517 2.343-3.087zm8.923 8.619l-1.447-1.523-1.091 1.874-1.284-1.55-1.566 1.945-1.406-1.81-1.69 1.545-1.288-1.431L5.88 16.18l-2.373-4.29 2.6 1.449 1.272-1.148 1.66 1.395 1.603-1.461 1.538 1.527 1.279-1.428 1.329 1.248.957-1.32 1.168.712 2.802-1.692-2.228 4.624z"
        fill={`url(#${id}-b)`}
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-a`}
          x1="9.125"
          x2="14.441"
          y1="5.259"
          y2="2.391"
        >
          <stop stopColor="#c86000" />
          <stop offset="1" stopColor="#ffb800" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-b`}
          x1="0.605"
          x2="19.32"
          y1="19.808"
          y2="-0.386"
        >
          <stop stopColor="#c86000" />
          <stop offset="1" stopColor="#ffb800" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function RatingIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("aspect-square size-4.5", className)}
      fill="none"
      preserveAspectRatio="xMinYMin meet"
      viewBox="0 0 18 18"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M4.4 8.398v6.77a.682.682 0 01-.677.676H.678A.68.68 0 010 15.168v-6.77c0-.371.307-.678.678-.678h3.045c.37 0 .678.307.678.678z"
        fill="#faa042"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M14.894 6.366h-2.93c.243-.975.898-1.346.898-2.707 0-2.485-2.83-4.603-3.543-.783-.213 1.028-2.554 4.751-3.595 4.833-.35.033-.645.328-.645.678v6.78c0 .372.317.666.675.676.371.013 1.006.233 1.671.466 1.144.391 2.572.89 4.084.89 1.962 0 4.183.365 3.963-2.406 1.032-.344 1.832-1.905 1.032-3.095 1.031-1.031.847-2.057 0-3.094 0 0 .688-1.72-1.61-2.238z"
        fill="#ffc850"
        fillRule="evenodd"
      />
    </svg>
  );
}

export function ScoreIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  const id = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("aspect-17/18 h-4.5 w-[17px]", className)}
      preserveAspectRatio="xMinYMin meet"
      viewBox="0 0 17 18"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M8.052 1.453c0-.573-.483-1.034-1.047-.934C3.024 1.23 0 4.731 0 8.944c0 .541.05 1.071.146 1.585.106.57.721.857 1.26.64l.668-.269c.475-.19.72-.71.656-1.217a5.95 5.95 0 01-.046-.74 5.849 5.849 0 014.454-5.692c.508-.123.914-.548.914-1.07v-.728z"
        fill="#41c9fa"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M8.905 2.152c-.008.532.406.969.925 1.09a5.849 5.849 0 014.486 5.702c0 3.233-2.604 5.854-5.816 5.854a5.797 5.797 0 01-4.735-2.455c-.304-.429-.856-.647-1.343-.446l-.657.27c-.527.217-.77.834-.47 1.318C2.8 15.897 5.464 17.5 8.501 17.5c4.694 0 8.5-3.83 8.5-8.556C17 4.72 13.96 1.21 9.96.514c-.557-.098-1.035.354-1.044.92l-.012.718z"
        fill={`url(#${id})`}
        fillRule="evenodd"
      />
      <defs>
        <radialGradient
          cx="0"
          cy="0"
          gradientTransform="matrix(.04763 8.54885 -8.30497 .04627 9.035 8.951)"
          gradientUnits="userSpaceOnUse"
          id={id}
          r="1"
        >
          <stop offset="0.179" stopColor="#ffc850" />
          <stop offset="0.503" stopColor="#ff5c00" />
        </radialGradient>
      </defs>
    </svg>
  );
}
